export default __webpack_public_path__ + "static/media/book-space-map.1140dbd5.png";